import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI.js'
import EmptyListUI from '../../../widgets/output/EmptyListUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import SwitchUI from '../../../widgets/action/SwitchUI.js'
import AllRepaymentNavUI from '../../../components/superUser/loanList/AllRepaymentNavUI.js'

const EMITrackerPageUI = ({ context, errorList, accountIncomeList, response, yearMonth, checked,
  onShowDetailsChange, onRefreshClick }) =>
  <SuperUserHomePageUI context={context} className='pg_su_emi_trk' topnav='accounts' dimension='w1600'
    headerText='IncomesMonthly' centered={!accountIncomeList && !errorList}
    page='repayments'
  >
    {
      !accountIncomeList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      accountIncomeList &&
      <>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
              <span className='g_m_left_100 g_large'><b>EMI Collections, {yearMonth.monthName} {yearMonth.year}</b></span>
            </span>
          }
          right={
            <span className='g_flex_h'>
              <span className='g_flex_h g_m_right_100'>
                <span className='g_muted g_small g_m_right_50 g_m_left_50'>
                  Loan breakup
                </span>
                <SwitchUI checked={checked} onChange={onShowDetailsChange} />
              </span>
              <span>
                <Link to={`/su/emis/${yearMonth.month == 1 ? yearMonth.year - 1 : yearMonth.year}/${yearMonth.month == 1 ? 12 : yearMonth.month - 1}`}>Previous</Link>
                <span className='g_m_left_100' />
                <Link to={`/su/emis/${yearMonth.month == 12 ? yearMonth.year + 1 : yearMonth.year}/${yearMonth.month == 12 ? 1 : yearMonth.month + 1}`}>Next</Link>
              </span>
            </span>

          }
        />
        <AllRepaymentNavUI context={context} type='collections' year={yearMonth.year} month={yearMonth.month} />
      </>
    }
    {
      accountIncomeList && response &&
      <BigNumberUI response={response} />
    }
    {
      accountIncomeList && accountIncomeList.length !== 0 &&
      <AccountIncomeUI
        accountIncomeList={response.accountIncomeList}
        onRefreshClick={onRefreshClick}
        response={response}
        checked={checked}
      />
    }
    {
      accountIncomeList && accountIncomeList.length === 0 &&
      <div className='g_m_top_50'>
        <EmptyListUI
          context={context}
          createEnabled={false}
          createDisabledMessageLabel='No data yet'
        />
      </div>
    }
  </SuperUserHomePageUI>

const BigNumberUI = ({ response }) =>
  <CardUI className='g_m_bottom_100'>
    <div className='g_flex_h'>
      <div>
        <span className='g_flex_v g_text_center'>
          <span className='g_xxxlarge'><b>{response.interestPaidF4}</b></span>
          <span>Total Interest Paid</span>
        </span>
      </div>
      <div>
        <span className='g_flex_v g_text_center'>
          <span className='g_xxxlarge'><b>{response.principalPaidF4}</b></span>
          <span>Total Principal Paid</span>
        </span>
      </div>
      <div>
        <span className='g_flex_v g_text_center'>
          <span className='g_xxxlarge'><b>{response.totalEmiPaidF4}</b></span>
          <span>Total EMI Paid</span>
        </span>
      </div>
      <div>
        <span className='g_flex_v g_text_center'>
          <span className='g_xxxlarge'><b>{response.totalPenaltyF4}</b></span>
          <span>Total Penalty Paid</span>
        </span>
      </div>
      <div>
        <span className='g_flex_v g_text_center'>
          <span className='g_xxxlarge'><b>{response.emiAndPenaltyF4}</b></span>
          <span>EMI and Penalty Paid</span>
        </span>
      </div>
    </div>
  </CardUI>

const AccountIncomeUI = ({ accountIncomeList, response, checked }) =>
  <div>
    <CardUI className='g_m_top_100'>
      <table>
        <thead>
          <tr className='head'>
            <td></td>
            <th className='left g_p_left_100'>Account/Loan</th>
            <th className='g_p_left_100'>Interest Paid</th>
            <th className='g_p_left_100'>Principal Paid</th>
            <th className='g_p_left_100'>Tax Paid</th>
            <th className='g_p_left_100'>Total EMI</th>
            <th className='g_p_left_100'>Penal Charge</th>
            <th className='g_p_left_100'>Dsra Dip Interest</th>
            <th className='g_p_left_100'>EMI and Penalty</th>
          </tr>
        </thead>
        <tbody>
          {
            accountIncomeList.map((account, i) =>
              <>
                <tr className='acc' key={i}>
                  <td className='left'>{i + 1}.</td>
                  <td className='left g_no_wrap_2'>{account.accountName}</td>
                  <td className='g_text_right amt'>{account.interestPaidF4}</td>
                  <td className='g_text_right amt'>{account.principalPaidF4}</td>
                  <td className='g_text_right amt'>{account.totalTaxPaidF4}</td>
                  <td className='g_text_right amt'>{account.totalEmiPaidF4}</td>
                  <td className='g_text_right amt'>{account.defaultIntPaidF4}</td>
                  <td className='g_text_right amt'>{account.dsraDipIntPaidF4}</td>
                  <td className='g_text_right amt'>{account.emiAndPenaltyF4}</td>
                </tr>
                {
                  checked && account.loanIncomeList && account.loanIncomeList.map((loan, j) =>
                    <tr className='left g_muted' key={j}>
                      <td className='left'>{i + 1}.{j + 1}</td>
                      <td className='left g_no_wrap_2'>{loan.loanName}</td>
                      <td className='g_text_right amt'>{loan.interestPaidF4}</td>
                      <td className='g_text_right amt'>{loan.principalPaidF4}</td>
                      <td className='g_text_right amt'>{loan.totalTaxPaidF4}</td>
                      <td className='g_text_right amt'>{loan.totalEmiPaidF4}</td>
                      <td className='g_text_right amt'>{loan.defaultIntPaidF4}</td>
                      <td className='g_text_right amt'>{loan.dsraDipIntPaidF4}</td>
                      <td className='g_text_right amt'>{loan.emiAndPenaltyF4}</td>
                    </tr>
                  )
                }
              </>
            )
          }
          <tr className='foot'>
            <td></td>
            <td className='left'><b>Total</b></td>
            <td className='g_text_right amt'><b>{response.interestPaidF4}</b></td>
            <td className='g_text_right amt'><b>{response.principalPaidF4}</b></td>
            <td className='g_text_right amt'><b>{response.totalTaxPaidF4}</b></td>
            <td className='g_text_right amt'><b>{response.totalEmiPaidF4}</b></td>
            <td className='g_text_right amt'><b>{response.defaultIntPaidF4}</b></td>
            <td className='g_text_right amt'><b>{response.dsraDipIntPaidF4}</b></td>
            <td className='g_text_right amt'><b>{response.emiAndPenaltyF4}</b></td>
          </tr>
        </tbody>
      </table>
    </CardUI>
  </div>

export default EMITrackerPageUI
